import { maskItem } from '@/components/DashboardCard/utils/maskItem';
import { isEmpty } from 'lodash';
import React from 'react';

import { DonutProps } from '../../interfaces';
import { DonutContainer, DonutContentContainer, DonutItem } from './styles';

const Donut: React.FC<{
  data: DonutProps[];
  separateDonuts: boolean;
  selectedDonuts: (string | number)[];
  onSelectedDonut: (id: string | number) => void;
  selectionType?: string;
}> = ({
  data: donuts,
  separateDonuts,
  selectedDonuts,
  onSelectedDonut,
  selectionType,
}) => {
  return (
    <DonutContainer
      minWidth={donuts.length * 78}
      separateDonuts={separateDonuts}
    >
      {donuts.map(
        ({
          id,
          color,
          label,
          value,
          maskValue,
          donutBorderWidth,
          donutSize,
          outsidelabel,
          outsidelabelStyles,
        }) => {
          const isActive = isEmpty(selectedDonuts)
            ? true
            : selectedDonuts?.includes(id);
          return (
            <DonutContentContainer
              separateDonuts={separateDonuts}
              onClick={() => onSelectedDonut(id)}
              canSelect={!!selectionType}
            >
              <p style={outsidelabelStyles}>{outsidelabel}</p>
              <DonutItem
                color={color}
                key={outsidelabel || label}
                donutBorderWidth={donutBorderWidth}
                donutSize={donutSize}
                active={isActive}
              >
                <div className="value">
                  {maskValue ? maskItem(maskValue, value) : value}
                </div>
                <div className="label">{label}</div>
              </DonutItem>
            </DonutContentContainer>
          );
        },
      )}
    </DonutContainer>
  );
};

export default Donut;
